module.exports = __webpack_public_path__ + "static/media/crow.23ee3ae8.svg";